/*!
 * @copyright
 * Copyright(c) 2018 SICK AG
 */
import { MaterialCache, Materials, Solids } from '@sick-davinci/glow';
import { Color, FrontSide, LineBasicMaterial, MeshBasicMaterial, Mesh, Vector3, Quaternion, Matrix4 } from 'three';
import { CrownTransform } from '../../CrownTransform';
import { LineSegments } from 'three';
/**
 * Base class vor all Crown shapes.
 * Contains materials for outline and fill area
 * as well as helper functions for creating shapes.
 */
export class CrownShape extends Mesh {
    // tslint:disable-next-line:no-any
    constructor(_source, decoration) {
        super();
        this._source = _source;
        decoration = CrownShape.ensureDecoration(decoration);
    }
    static ensureDecoration(decoration) {
        if (decoration == null) {
            decoration = {
                FillColor: {
                    R: 255,
                    G: 0,
                    B: 0,
                    A: 255,
                },
                LineColor: {
                    R: 0,
                    G: 0,
                    B: 0,
                    A: 255,
                },
                LineWidth: 1,
                PointSize: 1,
                PointType: null,
            };
        }
        return decoration;
    }
    /**
     * Creates and caches the materials depending on the materialDesc and decoration parameter.
     * If the materialDescParameter is present the material will be created through the Materials class
     * If the decoration paramter is present a default material is created
     *
     * @param decoration
     * @param material null or undefined are valid parameters
     * @param shapeSettings
     */
    static getFillMaterial(material, decoration, shapeSettings) {
        if (material != null) {
            return CrownShape._materialCacheFill.getMaterial(material, () => Materials.create(material));
        }
        if (shapeSettings == null) {
            shapeSettings = {
                side: FrontSide,
                depthWrite: true,
            };
        }
        if (shapeSettings.depthWrite == null) {
            shapeSettings.depthWrite = true;
        }
        if (shapeSettings.side == null) {
            shapeSettings.side = FrontSide;
        }
        Object.assign(decoration, shapeSettings);
        return CrownShape._materialCacheFill.getMaterial(decoration, () => new MeshBasicMaterial({
            side: shapeSettings.side,
            depthWrite: shapeSettings.depthWrite,
            opacity: decoration.FillColor.A / 255,
            transparent: decoration.FillColor.A < 255,
            color: new Color(decoration.FillColor.R / 255, decoration.FillColor.G / 255, decoration.FillColor.B / 255),
        }));
    }
    static getLineMaterial(decoration) {
        decoration = this.ensureDecoration(decoration);
        return CrownShape._materialCacheLine.getMaterial(decoration, () => new LineBasicMaterial({
            linewidth: decoration.LineWidth,
            opacity: decoration.LineColor.A / 255,
            transparent: decoration.LineColor.A < 255,
            color: new Color(decoration.LineColor.R / 255, decoration.LineColor.G / 255, decoration.LineColor.B / 255).getHex(),
        }));
    }
    transformPose() {
        const t = new Vector3();
        const r = new Quaternion();
        const s = new Vector3();
        this.matrix.decompose(t, r, s);
        const M = new Matrix4();
        M.compose(t, r, new Vector3(1, 1, 1)); // restore vector with scaling removed
        return { source: this._source, t, r, s, Matrix: CrownTransform.toArrays(M) };
    }
    addOutline(geometry, decoration) {
        const line = new LineSegments(Solids.createOutline(geometry), CrownShape.getLineMaterial(decoration));
        line.visible = decoration.LineWidth > 0;
        this.add(line);
    }
}
CrownShape._materialCacheLine = new MaterialCache();
CrownShape._materialCacheFill = new MaterialCache();
//# sourceMappingURL=CrownShape.js.map